module.exports = __webpack_public_path__ + "fonts/FuturaPT-Book.7721283f.woff";